const isDev = import.meta.env.MODE !== "production";

type Ctx = Record<string, unknown> | undefined;

export const logger = {
  info(message: string, ctx?: Ctx): void {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log(`[info] ${message}`, ctx ?? "");
    }
  },
  warn(message: string, ctx?: Ctx): void {
    // eslint-disable-next-line no-console
    console.warn(`[warn] ${message}`, ctx ?? "");
  },
  error(message: string, err?: unknown): void {
    // eslint-disable-next-line no-console
    console.error(`[error] ${message}`, err ?? "");
  },
};
